export enum TabAction {
  SEARCH,
  SAVE,
  DELETE,
  NEW,
  FILTER
}
